import { mapState, mapMutations } from 'vuex';
import protectedAxios from '../auth/axios.js';
import { eventBus } from '../main.js';
import utils from '../plugins/utils.js';
/*
    MIXIN pre kontorlku, ktora sa ma dynamicky nacitavat z db podla configu v tabulke sys_liw_view_controls
    a ma sa cachovat do tabulky liw_filip_controls_cache

    Po importovani mixinu:
        1.  ak je potrebne zabezpecit dodatocnu validaciu kontrolky v created() hooku
                if (nieco zle) {
                    this.valid = false
                }

        2.  v kontrolke implementovat metodu readData(config, data)
        3.  zavolat saveValue() podla potreby (lostFocus, created, click ...)

        4.  pridat :rules="getRules"
            pre rules je spraveny custom mechanizmus. Priamo v kontrolke pouzime pre rule AddRule, pri definovani rule na kontrolke pouzimeje prop :rule=""
        
        5. nabindovat :errorMessages="errorMessages"

        6. pridat ref="control"
*/
export const dynamicControlMixin = {
  props: {
    dynamic: Boolean,
    dataId: String,
    autoload: Boolean, //kontrolka sa nacita uplne nezavisle hned ako sa namountuje
    parentReloaded: Boolean, //doslova, poslem flag, ze form, v ktorom sa kontrolka nachadza uz zavolal reload(), vtedy sa kontrolka zavola loadData
    rules: Array,
    displayValidated: Boolean,
    readonly: Boolean,
    loading: Boolean,
    required: {
      type: Boolean,
      default: false,
    },
    cache: {
      type: Boolean,
      default: true,
    },
    label: String,
    tooltip: String,
    staticLabel: String,
    staticTooltip: String,
    isEnabled: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    cisloPlz: {
      type: String,
      default: null,
    },
    cisloPredmetu: {
      type: Number,
      default: null,
    },
    idZastupcu: {
      type: Number,
      default: null,
    },
    //ignoreInit pouzijeme na navesenej kontrolke, napr. v kontrolkach na karte OP
    //ignoreInit nastavuje hodnotu initComplete na mounted
    ignoreInit: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
    hideDetails: Boolean,
    hideLabel: Boolean,
    ignoreCompare:{
      type: Boolean,
      default: false,
    },
    lite: {
      type: Boolean,
      default : false
    },
    ignoreDirty: {
      type: Boolean,
      default : false
    },
    stopMouseDown: {
      type: Boolean,
      default: false, // Predvolené: nezastavuj mousedown
    },
    hideTooltip:{
      type: Boolean,
      default: false
    }
  },
  //tu lezie objekt wizrd formularu, na ktorom je kontrokla
  inject: {
    wizardForm: {
      default: null,
    },
  },
  data() {
    return {
      callApiAgain: true,
      cacheValue: null,
      isLoading: false,
      isSaving: false,
      valid: true,
      internalRules: [],
      ruleIndex: 0,
      ruleResults: [],
      hasError: false,
      errorMessages: null,
      saveLoadError:false,
      dirty: false, //pouzivatel klikol na kontrolku, osahal ju, dirty sa zmeni na true
      initComplete: false,
      l_label: this.label,
      l_tooltip: this.tooltip,
      l_required: this.required,
      l_isEnabled: this.isEnabled,
      l_visible: this.visible,
      l_dataId: this.dataId,
      l_autoload: this.autoload,
      l_ignoreInit: this.ignoreInit,
      l_cisloPredmetu: this.cisloPredmetu,
      isMounted: false,
      customDataLoadedEmit: false,
      dataIsLoaded: false,
      l_minValue: null,
      l_maxValue: null
    };
  },
  computed: {
    ...mapState(['pripad', 'wizardFormControls','timeToCallApiAgain']),
    cmpLabel() {
      return this.l_label;
    },
    cmpRequired() {
      return this.l_required;
    },
    getLabel() {
      return this.staticLabel ?? this.l_label;
    },
    getTooltip() {
      return this.staticTooltip ?? this.l_tooltip;
    },
    getRules() {
      if (this.rules === undefined) {
        return this.internalRules;
      } else {
        return [...this.rules, ...this.internalRules];
      }
    },
    getFormName() {
      if (this.wizardForm) return this.wizardForm.controlName;

      //lebo niekde sa pouziva wizardMixin dokopy s tymto mixinom
      return this.controlName;
    },
    showValidatedIcon() {
      return !this.hasError;
    },
    ///ak potrebujem zavolat loadData az vtedy, ked sa zavolal na parentovi reaload a zaroven kontrolka je uz mounted
    readyForLoad() {
      return this.parentReloaded && this.isMounted;
    },
    isLoadingOrSaving() {
      return this.isLoading || this.isSaving;
    },
    isDisabled() {
      return !this.l_isEnabled || (!!this.pripad.predmetZamknuty && !!this.l_cisloPredmetu);
    },
  },
  watch: {
    cisloPredmetu(val) {
      this.l_cisloPredmetu = val;
    },
    errorMessages() {
      this.hasError = !!this.errorMessages;
    },
    isEnabled(val) {
      this.l_isEnabled = val;
    },
    readyForLoad(val) {
      if (val) this.loadData();
    },
    l_isEnabled(val) {
      this.$emit('enabledChanged', val);
    },
    isLoadingOrSaving(val) {
      this.setFormControlLoading({
        formName: this.getFormName,
        dataId: this.l_dataId,
        isLoading: val,
        cisloPredmetu: this.l_cisloPredmetu,
      });
    },
  },
  methods: {
    ...mapMutations([
      'setFormControl',
      'deleteFormControl',
      'setFormControlDirty',
      'setFormControlInitCompleted',
      'setFormControlLoading',
    ]),
    showStyle() {
      if (this.show) return null;

      return {
        display: 'none',
      };
    },
    saveValue(value, _ignoreDirty = false) {
      this.cacheValue = value;

      if (!this.initComplete) return Promise.resolve();

      if (this.lite) return Promise.resolve();

      //console.log('SAVE VALIDATE', this.l_dataId, this.$refs.control?.validate(), value)
      if (!this.cache && this.l_dataId){
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("saveValue cache",!this.cache,this.l_dataId)
        } 
        return Promise.resolve();
      }

      if (!this.valid || (this.$refs.control?.validate() === false && !_ignoreDirty)){
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("saveValue valid",!this.valid,this.$refs.control?.validate(),!_ignoreDirty)
        }
        return Promise.resolve();
      }
      
      if (this.isLoading){
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("saveValue loading",this.isLoading)
        }
        return Promise.resolve();
      }

      if (!(this.dirty || _ignoreDirty)){
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("saveValue dirty",this.dirty,_ignoreDirty)
        }
        return Promise.resolve();
      }

      if (Array.isArray(this.cacheValue)) {
        this.cacheValue = this.cacheValue.join();
      }

      this.isSaving = true;

      console.log('SAVING DATA', this.l_dataId, this.dirty)

      return protectedAxios
        .post(
          `controls/cache`,
          {
            viewObjectId: this.l_dataId,
            cisloPlz: this.cisloPlz,
            newId: this.pripad?.newId ?? utils.GuidEmpty(),
            value: this.cacheValue ?? null,
            cisloPredmetu: this.l_cisloPredmetu,
            idZastupcu: this.idZastupcu,
            dirty: this.dirty
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          //console.log('VALUE CHANGED', this.l_dataId)
          this.saveLoadError = false;
          this.callApiAgain = true;
          this.errorMessages = null;
          this.saveLoadError = false;
          this.$emit('valueChanged', this.cacheValue);
        })
        .catch(e => {
          console.error(this.l_dataId, e);
          if(e?.onlyInterceptor){
            this.saveLoadError = true;
            this.errorMessages = 'Chyba pri ukladaní hodnoty.';
            return;
          }
          if(this.timeToCallApiAgain != 0 && this.callApiAgain){
            setTimeout(()=>{
              this.callApiAgain = false;
              this.saveValue(value,_ignoreDirty)
            },this.timeToCallApiAgain)
          }else{
            this.saveLoadError = true;
            this.errorMessages = 'Chyba pri ukladaní hodnoty.';
            if(!this.l_visible)
              eventBus.$emit('snack-error', 'Chyba pri ukladaní hodnoty.');
          }
        })
        .finally(() => (this.isSaving = false));
    },
    getCacheValue() {
      return this.cacheValue;
    },
    setDirty(dirty) {
      this.dirty = dirty; //&& this.l_isEnabled && !this.readonly;
      if (this.getFormName)
        this.setFormControlDirty({
          formName: this.getFormName,
          dataId: this.l_dataId,
          dirty: this.dirty,
          cisloPredmetu: this.l_cisloPredmetu,
        });
    },
    getDirty() {
      return this.dirty;
    },
    async loadSettings() {
      if (!this.valid || !this.l_dataId) {
        this.addDefaultRules();
        return;
      }

      return await protectedAxios
        .get(`controls/settings/${this.l_dataId}`)
        .then(res => {
          this.callApiAgain = true;
          if (!this.dataIsLoaded) {
            this.l_isEnabled = res.data.is_enabled;
            this.l_required = res.data.is_required;
            this.l_visible = res.data.is_visible;
            this.l_label = res.data.view_object_text;
            this.l_tooltip = res.data.view_object_info_text;
            this.l_minValue = res.data.min_value;
            this.l_maxValue = res.data.max_value;
          }
          this.errorMessages = null;
          this.saveLoadError = false;
          this.addDefaultRules();
        })
        .catch(e => {
          console.error(this.l_dataId, e);
          if(this.timeToCallApiAgain != 0 && this.callApiAgain){
            setTimeout(async ()=>{
              this.callApiAgain = false;
              await this.loadSettings()
            },this.timeToCallApiAgain)
          }else{
            this.isLoading = false;
            this.saveLoadError = true;
            this.errorMessages = 'Chyba pri načítaní dát.';
            eventBus.$emit('snack-error', 'Chyba pri načítaní dát.');
          }  
        });
    },
    loadData() {
      if (!this.valid) Promise.resolve();

      if (!this.l_dataId) {
        return Promise.resolve();
      }

      //console.log('Loading data ...', this.l_dataId)

      this.isLoading = true;
      this.dataError = false;
      if(this.lite){
        return protectedAxios
        .get(
          `controls/lite?ViewObjectId=${this.l_dataId}`
        )
        .then(res => {
          return this.loadDataResponse(res);
        })
        .catch(e => {
          return this.loadDataCache(e);
        }).finally(()=>{
          this.isLoading = false;
        });
      }else{
        return protectedAxios
          .get(
            `controls?ViewObjectId=${this.l_dataId}&NewId=${this.pripad?.newId ?? utils.GuidEmpty()}&CisloPredmetu=${this.l_cisloPredmetu ?? ''}&CisloPlz=${encodeURIComponent(this.cisloPlz ?? '')
            }&IdZastupcu=${this.idZastupcu ?? ''}`
          )
          .then(res => {
            return this.loadDataResponse(res);
          })
          .catch(e => {
            return this.loadDataCache(e);
          }).finally(()=>{
            this.isLoading = false;
            //console.log("dataLoadedAndLoading",this.l_dataId);
            this.$emit("dataLoadedAndLoading")
          });
      }
    },
    loadDataResponse(res){
      this.dataIsLoaded = true;
      this.l_isEnabled = !!res.data.config.is_enabled;
      this.l_required = !!res.data.config.is_required;
      this.l_visible = !!res.data.config.is_visible;
      this.l_label = res.data.config.viewObjectText;
      this.l_tooltip = res.data.config.viewObjectInfoText;
      this.l_minValue = res.data.config.min_value;
      this.l_maxValue = res.data.config.max_value;

      this.errorMessages = null;
      this.saveLoadError = false;
      this.callApiAgain = true;
      this.addDefaultRules()
      this.setInitComplete(true);
      return this.dataLoaded(res);
    },
    loadDataCache(e){
      console.error(this.l_dataId, e);
      if(e?.onlyInterceptor){
        this.setInitComplete(true);
        this.isLoading = false;
        this.saveLoadError = true;
        this.errorMessages = 'Chyba pri načítaní dát.';
        return;
      }
      if(this.timeToCallApiAgain != 0 && this.callApiAgain){
        setTimeout(()=>{
          this.callApiAgain = false;
          this.loadData()
        },this.timeToCallApiAgain)
      }else{
        console.log("error",this.l_dataId)
        this.setInitComplete(true);
        this.isLoading = false;
        this.saveLoadError = true;
        this.errorMessages = 'Chyba pri načítaní dát.';
        
        if(!this.l_visible)
          eventBus.$emit('snack-error', 'Chyba pri načítaní dát.');
      }
    },
    dataLoaded(res) {
      if (!this.customDataLoadedEmit) {
        this.$emit('dataLoaded', res.data.config.controlValue);
        //console.log('DATA LOADED', this.l_dataId)
      }
      this.saveLoadError = false;
      if (res.status === 200) {
        return this.readData(res.data.config, res.data.data);
      } else if (res.status == 204) {
        console.warn(`Neexistuju data pre kontrolku data-id: '${this.l_dataId}'.`);
        this.data = [];
      } else {
        console.error(`Chyba pri nacitani dat. data-id: '${this.l_dataId}'.`);
        this.saveLoadError = true;
        this.errorMessages = 'Chyba pri načítaní dát.';
      }
    },
    addDefaultRules() {
      if (this.l_required) {
        this.addRule(v => !!v || v === 0 || 'Povinné pole');
      }else{
        this.removeRule(v => !!v || v === 0 || 'Povinné pole');
      }
    },
    addRule(rule) {
      const ruleString = rule.toString();
      const ruleExists = this.internalRules.some(existingRule => existingRule.toString() === ruleString);
      if (!ruleExists) {
        this.internalRules.push(rule);
      }
    },
    removeRule(rule) {
      const ruleString = rule.toString();
      const ruleExists = this.internalRules.findIndex(existingRule => existingRule.toString() === ruleString);
      if (ruleExists > -1) {
        this.internalRules.splice(ruleExists, 1);
        this.$refs['control']?.resetValidation()
      }
    },
    setInitComplete(val) {
      this.initComplete = val;
      if (this.getFormName) {
        this.setFormControlInitCompleted({
          formName: this.getFormName,
          dataId: this.l_dataId,
          initComplete: this.initComplete,
          cisloPredmetu: this.l_cisloPredmetu,
        });
      }
    },
    setValueWithDirty(val){
      this.setDirty(true);
      return this.setValue(val)
    },
    handleMouseDown(event) {
      if (this.stopMouseDown) {
        event.stopPropagation(); // Zastaví šírenie udalosti mousedown
      }
    },
  },
  async mounted() {
    this.setInitComplete(this.l_ignoreInit);
    
    await this.loadSettings().then(() => {
      this.isMounted = true;
      if (this.l_autoload) {
        this.loadData();
      }

    });
    
  },
  beforeCreate() {
    eventBus.$on('resetControlDirty', formName => {
      if (this.getFormName === formName) {
        this.setDirty(false);
      }
    });
  },
  beforeMount() {
    if (this.getFormName) {
      this.setFormControl({
        formName: this.getFormName ?? 'NO_FORM_NAME',
        dataId: this.l_dataId,
        initComplete: this.l_ignoreInit,
        dirty: false,
        isLoading: false,
        cisloPredmetu: this.l_cisloPredmetu,
      });
    }
  },
  created() {
    this.$on('input', val => {
      //pri dynamickych rules blbne validacia na lost focus, preto ju treba vyvolat automaticky
      if (this.$refs.control && this.dirty) {
        this.$refs.control.validate();
      }
    });
  },
  beforeDestroy() {
    this.deleteFormControl({
      formName: this.getFormName ?? 'NO_FORM_NAME',
      dataId: this.l_dataId,
      cisloPredmetu: this.l_cisloPredmetu,
    });
  },
};
